"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums");

var NumberVariableConverter_1 = require("./NumberVariableConverter");

var TypedObjectBaseConverter_1 = require("./TypedObjectBaseConverter");

var ToggleFunctionBaseConverter =
/** @class */
function (_super) {
  __extends(ToggleFunctionBaseConverter, _super);

  function ToggleFunctionBaseConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ToggleFunctionBaseConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  ToggleFunctionBaseConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return ToggleFunctionBaseConverter;
}(TypedObjectBaseConverter_1.TypedObjectBaseConverter);

exports.ToggleFunctionBaseConverter = ToggleFunctionBaseConverter;

var PauseToggleFunctionConverter =
/** @class */
function (_super) {
  __extends(PauseToggleFunctionConverter, _super);

  function PauseToggleFunctionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PauseToggleFunctionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  PauseToggleFunctionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return PauseToggleFunctionConverter;
}(ToggleFunctionBaseConverter);

exports.PauseToggleFunctionConverter = PauseToggleFunctionConverter;

var PlayToggleFunctionConverter =
/** @class */
function (_super) {
  __extends(PlayToggleFunctionConverter, _super);

  function PlayToggleFunctionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PlayToggleFunctionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  PlayToggleFunctionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return PlayToggleFunctionConverter;
}(ToggleFunctionBaseConverter);

exports.PlayToggleFunctionConverter = PlayToggleFunctionConverter;

var TimeUpdateToggleFunctionConverter =
/** @class */
function (_super) {
  __extends(TimeUpdateToggleFunctionConverter, _super);

  function TimeUpdateToggleFunctionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TimeUpdateToggleFunctionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      time: NumberVariableConverter_1.numberVariableConverter.fromMessage(message.time)
    });
  };

  TimeUpdateToggleFunctionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      time: NumberVariableConverter_1.numberVariableConverter.toMessage(object.time)
    });
  };

  return TimeUpdateToggleFunctionConverter;
}(ToggleFunctionBaseConverter);

exports.TimeUpdateToggleFunctionConverter = TimeUpdateToggleFunctionConverter;
exports.pauseToggleFunctionConverter = new PauseToggleFunctionConverter();
exports.playToggleFunctionConverter = new PlayToggleFunctionConverter();
exports.timeUpdateToggleFunctionConverter = new TimeUpdateToggleFunctionConverter();

var ToggleFunctionConverter =
/** @class */
function () {
  function ToggleFunctionConverter() {}

  ToggleFunctionConverter.prototype.fromMessage = function (message) {
    switch (message.type) {
      case enums_1.ToggleFunctionType.OnPause:
        return exports.pauseToggleFunctionConverter.fromMessage(message);

      case enums_1.ToggleFunctionType.OnPlay:
        return exports.playToggleFunctionConverter.fromMessage(message);

      case undefined:
        return exports.timeUpdateToggleFunctionConverter.fromMessage(__assign({
          type: enums_1.ToggleFunctionType.TimeUpdate
        }, message));

      case enums_1.ToggleFunctionType.TimeUpdate:
        return exports.timeUpdateToggleFunctionConverter.fromMessage(message);
    }
  };

  ToggleFunctionConverter.prototype.toMessage = function (object) {
    switch (object.type) {
      case enums_1.ToggleFunctionType.OnPause:
        return exports.pauseToggleFunctionConverter.toMessage(object);

      case enums_1.ToggleFunctionType.OnPlay:
        return exports.playToggleFunctionConverter.toMessage(object);

      case enums_1.ToggleFunctionType.TimeUpdate:
        return exports.timeUpdateToggleFunctionConverter.toMessage(object);
    }
  };

  return ToggleFunctionConverter;
}();

exports.ToggleFunctionConverter = ToggleFunctionConverter;
exports.toggleFunctionConverter = new ToggleFunctionConverter();